import { useState, type FormEvent, type ReactElement } from "react";
import { trpc } from "../../api";
import { useI18n } from "../../i18n";
import { ErrorNotice } from "../../ui";

export function SignInPage({ onSignedIn, onForgotPassword }: {
  readonly onSignedIn: () => void;
  readonly onForgotPassword: () => void;
}): ReactElement {
  const { t, locale, setLocale } = useI18n();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const signIn = trpc.auth.signIn.useMutation({ onSuccess: onSignedIn });

  function submit(event: FormEvent): void {
    event.preventDefault();
    signIn.mutate({ username, password });
  }

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={submit}>
        <h1 style={{ textAlign: "center", color: "var(--brand)" }}>{t("common.appName")}</h1>

        <ErrorNotice error={signIn.error} />

        <div className="field">
          <label htmlFor="username">{t("common.username")}</label>
          <input
            id="username" name="username" autoComplete="username" autoFocus required
            value={username} onChange={(e) => setUsername(e.target.value)}
          />
        </div>

        <div className="field">
          <label htmlFor="password">{t("common.password")}</label>
          <input
            id="password" name="password" type="password" autoComplete="current-password" required
            value={password} onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button type="submit" className="btn btn-primary" style={{ width: "100%" }} disabled={signIn.isPending}>
          {signIn.isPending ? t("common.loading") : t("common.signIn")}
        </button>

        {/* A link, not a button: it is a way out of this page rather than an
            action on the form, and it must not look like a second way to
            submit. Above the language toggle because somebody who is locked out
            is looking for it, not for English. */}
        <button
          type="button" className="btn-link" style={{ width: "100%", marginTop: "var(--space-3)" }}
          onClick={onForgotPassword}
        >
          {t("auth.forgotLink")}
        </button>

        <button
          type="button" className="btn btn-sm" style={{ width: "100%", marginTop: "var(--space-3)" }}
          onClick={() => setLocale(locale === "en" ? "ar" : "en")}
        >
          {locale === "en" ? "العربية" : "English"}
        </button>
      </form>
    </div>
  );
}
